export default "__VITE_ASSET__DKvWlYx0__"